export default __webpack_public_path__ + "8ee33a6.png";